// SPDX-License-Identifier: MIT
// Small store-seam helpers the continuity hydration needs that the base stores
// don't expose: a per-entry syncmap setter (the store only has full load/save) and
// a dedup-by-version_number append (appendVersion has no dedup guard).
import { loadSyncMap, saveSyncMap } from './syncmap-store';
import { listVersionsForProject, appendVersion } from './version-store';
import type { ProjectVersionRow } from '../projects/api';

export async function setSyncMapEntry(localId: string, cloudId: string): Promise<void> {
  const map = await loadSyncMap();
  map[localId] = cloudId;
  await saveSyncMap(map);
}

// Append only the rows whose version_number the project does not already have.
// Returns how many were appended (0 → fully idempotent). Assumes all rows share
// one project_id (the hydration target); reads that project's existing numbers once.
export async function appendVersionsDedup(rows: ProjectVersionRow[]): Promise<number> {
  if (rows.length === 0) return 0;
  const pid = rows[0].project_id;
  const have = new Set((await listVersionsForProject(pid)).map((v) => v.version_number));
  let added = 0;
  for (const r of rows) {
    if (have.has(r.version_number)) continue;
    await appendVersion(r);
    have.add(r.version_number);
    added++;
  }
  return added;
}
